// const TestmonyTextSection = () => {
//   const COLORS = {
//     primaryOrange: '#e46324',
//     primaryGreen: '#5ec250',
//     primaryDarkBlue: '#016563',
//     textOrange: '#e46d3e',
//     cardBg: '#ffffff',
//     borderColor: '#e0e0e0',
//     lightGray: '#f0f0f0',
//     darkGray: '#333',
//     mediumDarkGray: '#555',
//     newTagRed: '#ff4444',
//     disabledGray: '#cccccc',
//   };

//   const styles = {
//     mainContainerStyle: {
//       backgroundColor: COLORS.lightGray,
//       padding: '10px 20px',
//       width: '100%',
//       boxSizing: 'border-box',
//     },
//     titleStyle: {
//       color: '#333',
//       fontSize: 'clamp(20px, 2vw, 28px)',
//       fontWeight: 700,
//       marginBottom: '20px',
//       textAlign: 'center',
//       lineHeight: '1.3',
//     },
//     detailsTitleStyle: {
//       color: COLORS.darkGray,
//       fontSize: 'clamp(14px, 1.6vw, 16px)',
//       lineHeight: '1.6',
//       marginBottom: '15px',
//     },
//     faqQuestionStyle: {
//       fontWeight: 'bold',
//       color: COLORS.primaryDarkBlue,
//       fontSize: 'clamp(16px, 1.8vw, 18px)',
//       marginTop: '25px',
//       marginBottom: '10px',
//       lineHeight: '1.4',
//     },
//     faqAnswerStyle: {
//       marginLeft: '0',
//       marginBottom: '20px',
//       color: COLORS.darkGray,
//       fontSize: 'clamp(14px, 1.6vw, 16px)',
//       lineHeight: '1.6',
//       paddingLeft: '10px',
//     },
//     listStyle: {
//       paddingLeft: '20px',
//       marginBottom: '20px',
//     },
//     listItemStyle: {
//       marginBottom: '8px',
//       fontSize: 'clamp(14px, 1.6vw, 16px)',
//       lineHeight: '1.6',
//     }
//   };

//   return (
//     <>
//       <div style={styles.mainContainerStyle}>
//         <h2 style={styles.titleStyle}>Frequently Asked Questions – Buying Flats & Apartments in Trichy</h2>

//         <div style={styles.faqQuestionStyle}>
//           What types of properties does Mitha Homes offer in Trichy?
//         </div>
//         <p style={styles.detailsTitleStyle}>
//           We offer apartments, premium flats, luxury apartments, and selected houses for sale across Trichy's top residential locations.
//         </p>

//         <div style={styles.faqQuestionStyle}>
//           Are new flats for sale in Trichy a good investment?
//         </div>
//         <p style={styles.detailsTitleStyle}>
//           Yes. Trichy's growing infrastructure, educational institutions, and improving connectivity make it a stable and promising real estate market.
//         </p>

//         <div style={styles.faqQuestionStyle}>
//           Do you offer 3 BHK flats for sale in Trichy?
//         </div>
//         <p style={styles.detailsTitleStyle}>
//           Yes, we have spacious 3 BHK apartments designed for modern families, with premium specifications and excellent layouts.
//         </p>

//         <div style={styles.faqQuestionStyle}>
//           Are high-budget flats available with Mitha Homes?
//         </div>
//         <p style={styles.detailsTitleStyle}>
//           Absolutely. We offer high-budget flats and luxury apartments in Trichy for buyers seeking premium living.
//         </p>

//         <div style={styles.faqQuestionStyle}>
//           Is Trichy suitable for family living?
//         </div>
//         <p style={styles.detailsTitleStyle}>
//           Trichy is known for its cultural heritage, peaceful lifestyle, good educational institutions, and healthcare facilities—making it an excellent city for families.
//         </p>

//         <h2 style={styles.titleStyle}>Why Choose Mitha Homes?</h2>
//         <p style={styles.detailsTitleStyle}>Choosing the right builder is as important as choosing the right home. Mitha Homes stands for trust, transparency, and uncompromising quality.</p>

//         <p style={styles.detailsTitleStyle}>What sets us apart:</p>
//         <ul style={styles.listStyle}>
//           <li style={styles.listItemStyle}>Proven expertise in residential development</li>
//           <li style={styles.listItemStyle}>Clear legal documentation & approvals</li>
//           <li style={styles.listItemStyle}>Customer-centric approach</li>
//           <li style={styles.listItemStyle}>Strategic project locations</li>
//           <li style={styles.listItemStyle}>Strong focus on long-term value</li>
//         </ul>

//         <p style={styles.detailsTitleStyle}>Our goal is not just to sell flats, but to help you invest in a home you can be proud of.</p>

//         <h2 style={styles.titleStyle}>Find Your Ideal Home in Trichy with Mitha Homes</h2>
//         <p style={styles.detailsTitleStyle}>
//           Whether you are searching for flats for sale in Trichy, a premium apartment, or a house below ₹3 crore, Mitha Homes is your trusted partner in making the right choice.
//         </p>
//         <p style={styles.detailsTitleStyle}>
//           📞 Contact Mitha Homes today to schedule a site visit and take the next step toward owning a home that reflects your success and aspirations.
//         </p>
//       </div>
//     </>
//   );
// };

// export default TestmonyTextSection;

import { useState } from "react";

const TestmonyTextSection = () => {
  const COLORS = {
    primaryGreen: "#5ec250",
    border: "#e6e6e6",
    textDark: "#0f172a",
    textLight: "#64748b",
    bg: "#fff",
  };

  const faqs = [
    {
      q: "What types of properties does Mitha Homes offer in Trichy?",
      a: "We offer apartments, premium flats, luxury apartments, and selected houses for sale across Trichy's top residential locations.",
    },
    {
      q: "Are new flats for sale in Trichy a good investment?",
      a: "Yes. Trichy's growing infrastructure, educational institutions, and improving connectivity make it a stable and promising real estate market.",
    },
    {
      q: "Do you offer 3 BHK flats for sale in Trichy?",
      a: "Yes, we have spacious 3 BHK apartments designed for modern families, with premium specifications and excellent layouts.",
    },
    {
      q: "Are high-budget flats available with Mitha Homes?",
      a: "Absolutely. We offer high-budget flats and luxury apartments in Trichy for buyers seeking premium living.",
    },
    {
      q: "Is Trichy suitable for family living?",
      a: "Trichy is known for its cultural heritage, peaceful lifestyle, good educational institutions, and healthcare facilities—making it an excellent city for families.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div
      style={{
        backgroundColor: COLORS.bg,
        marginTop: "40px",
      }}
    >
      <div
        style={{
          backgroundColor: COLORS.bg,

          maxWidth: "900px",
          margin: "0 auto",
          padding: "60px 20px",
          fontFamily: "'Plus Jakarta Sans', sans-serif",
        }}
      >
        {/* TITLE */}
        <h2 style={{ textAlign: "center", fontSize: "32px", fontWeight: 500 }}>
          Frequently asked questions
        </h2>
        <p
          style={{
            textAlign: "center",
            color: COLORS.textLight,
            marginBottom: "40px",
          }}
        >
          Everything you need to know about the product and billing.
        </p>

        {/* FAQ LIST */}
        {faqs.map((item, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={index}
              style={{
                borderBottom: `1px solid ${COLORS.border}`,
                padding: "22px 0",
              }}
            >
              {/* QUESTION */}
              <div
                onClick={() => setOpenIndex(isOpen ? null : index)}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <h4
                  style={{
                    fontSize: "18px",
                    fontWeight: 400,
                    color: COLORS.textDark,
                    margin: 0,
                    paddingRight: "20px",
                  }}
                >
                  {item.q}
                </h4>

                {/* ICON */}
                <span
                  style={{
                    width: "26px",
                    height: "26px",
                    borderRadius: "50%",
                    border: `2px solid ${COLORS.primaryGreen}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: COLORS.primaryGreen,
                    fontSize: "18px",
                    fontWeight: 400,
                    flexShrink: 0,
                  }}
                >
                  {isOpen ? "−" : "+"}
                </span>
              </div>

              {/* ANSWER */}
              <div
                style={{
                  maxHeight: isOpen ? "200px" : "0px",
                  overflow: "hidden",
                  transition: "all 0.55s ease",
                  opacity: isOpen ? 1 : 0,
                }}
              >
                <p
                  style={{
                    marginTop: "14px",
                    fontSize: "16px",
                    lineHeight: 1.7,
                    color: COLORS.textLight,
                    maxWidth: "800px",
                  }}
                >
                  {item.a}
                </p>
              </div>
            </div>
          );
        })}

        <FaqContactCTA />
        <WhyChooseMithaHomes />
        <FindIdealHomeSection />
      </div>
    </div>
  );
};

const FaqContactCTA = () => {
  const COLORS = {
    bg: "#F9FAFB",
    textDark: "#0f172a",
    textLight: "#64748b",
    green: "#5ec250",
  };

  return (
    <div
      style={{
        maxWidth: "1000px",
        margin: "30px auto 0",
        padding: "30px 20px",
        fontFamily: "'Plus Jakarta Sans', sans-serif",
      }}
    >
      <div
        style={{
          background: COLORS.bg,
          borderRadius: "5px",
          padding: "40px 20px",
          textAlign: "center",
        }}
      >
        {/* AVATARS */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "16px",
          }}
        >
          {/* Replace src with your SVG paths */}
          {/* {["/icons/avatars.svg"].map((src, i) => ( */}
          <img
            key={"team member"}
            src={"/icons/avatars.svg"}
            alt="Team member"
            style={{
              width: "104px",
              // height: "84px",
              // borderRadius: "50%",
              // border: "2px solid #fff",
              // marginLeft: i === 0 ? "0" : "-12px",
              // background: "#fff",
            }}
          />
          {/* ))} */}
        </div>

        {/* TEXT */}
        <h3
          style={{
            fontSize: "22px",
            fontWeight: 500,
            color: COLORS.textDark,
            marginBottom: "10px",
          }}
        >
          Still have questions?
        </h3>

        <p
          style={{
            fontSize: "16px",
            color: COLORS.textLight,
            maxWidth: "520px",
            margin: "0 auto 24px",
            lineHeight: 1.6,
          }}
        >
          Can’t find the answer you’re looking for? Please call our friendly
          team.
        </p>

        {/* BUTTON */}
        <a href="https://mithahomes.com/contact">
          <button
            style={{
              background: COLORS.green,
              color: "#fff",
              border: "none",
              padding: "12px 28px",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Contact us
          </button>
        </a>
      </div>
    </div>
  );
};

const WhyChooseMithaHomes = () => {
  return (
    <div className="why-wrapper">
      <h2 className="why-title">
        Why Choose <span>Mitha Homes Flats in Trichy</span>?
      </h2>

      <p className="why-subtitle">
        Choosing the right builder is as important as choosing the right home.
        Mitha Homes stands for trust, transparency, and uncompromising quality.
      </p>

      <div className="why-grid">
        <div className="why-item">
          <img
            src="/icons/streamline-ultimate_job-responsibility-bag-hand.svg"
            alt=""
          />
          <p>Proven expertise in residential development</p>
        </div>

        <div className="why-item">
          <img src="/icons/mi_document.svg" alt="" />
          <p>Clear legal documentation & approvals</p>
        </div>

        <div className="why-item">
          <img src="/icons/ix_customer.svg" alt="" />
          <p>Customer-centric approach</p>
        </div>

        <div className="why-item">
          <img src="/icons/mdi_locations-outline.svg" alt="" />
          <p>Strategic project locations</p>
        </div>

        <div className="why-item">
          <img src="/icons/icon-park-outline_time.svg" alt="" />
          <p>Strong focus on long-term value</p>
        </div>
      </div>

      <p className="why-footer">
        Our goal is not just to sell flats, but to help you invest in a home you
        can be proud of.
      </p>

      <style>{`
  .why-wrapper {
    font-family: 'Plus Jakarta Sans', sans-serif;
    max-width: 1100px;
    margin: 0 auto;
    padding: 80px 20px;
    text-align: center;
  }

  .why-title {
    font-size: 34px;
    font-weight: 500;
    color: #111827;
    margin-bottom: 12px;
  }

  .why-title span {
    color: #63c153;
  }

  .why-subtitle {
    font-size: 16px;
    color: #6b7280;
    max-width: 720px;
    margin: 0 auto 60px;
    line-height: 1.6;
  }

  /* DESKTOP GRID */
  .why-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 40px 20px;
  }

  .why-item {
    grid-column: span 2;
    max-width: 260px;
    margin: 0 auto;
    text-align: center;
  }

  .why-item img {
    width: 36px;
    height: 36px;
    margin-bottom: 16px;
  }

  .why-item p {
    font-size: 16px;
    font-weight: 500;
    color: #374151;
    line-height: 1.4;
  }

  /* PERFECT CENTER FOR DESKTOP SECOND ROW */
  .why-item:nth-child(4) {
    grid-column: 2 / span 2;
  }

  .why-item:nth-child(5) {
    grid-column: 4 / span 2;
  }

  .why-footer {
    margin-top: 50px;
    font-size: 16px;
    color: #6b7280;
  }

  /* ===================== */
  /* 📱 MOBILE FIX */
  /* ===================== */
  @media (max-width: 768px) {

    .why-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .why-item {
      grid-column: auto !important;
      max-width: 100%;
    }

    /* Center last item */
    .why-item:nth-child(5) {
      grid-column: 1 / -1 !important;
      justify-self: center;
      max-width: 260px;
    }
  }
`}</style>
    </div>
  );
};

const FindIdealHomeSection = () => {
  const green = "#63c153";

  const styles = {
    wrapper: {
      maxWidth: "1100px",
      margin: "0 auto",
      padding: "10px 20px",
      textAlign: "center",
    },

    title: {
      fontSize: "36px",
      fontWeight: 500,
      color: "#111827",
      lineHeight: 1.3,
      marginBottom: "20px",
    },

    subtitle: {
      fontSize: "16px",
      color: "#6b7280",
      maxWidth: "820px",
      margin: "0 auto 40px",
      lineHeight: 1.6,
    },

    ctaBox: {
      background: "#f9fafb",
      borderRadius: "16px",
      padding: "30px 20px",
      maxWidth: "900px",
      margin: "0 auto",
    },

    phone: {
      fontSize: "20px",
      fontWeight: 500,
      color: "#4c5056",
      marginBottom: "12px",
    },

    ctaText: {
      fontSize: "16px",
      color: "#6b7280",
      lineHeight: 1.6,
    },

    // Mobile tweaks
    mobile: {
      title: {
        fontSize: "28px",
      },
    },
  };

  return (
    <div style={styles.wrapper}>
      <h2
        style={{
          ...styles.title,
        }}
      >
        Find Your Ideal 3 Bhk Flats in Trichy with <br />
        <span style={{ color: green }}>Mitha Homes</span>
      </h2>

      <p style={styles.subtitle}>
        Whether you are searching for flats for sale in Trichy, a premium
        apartment, or a house below ₹3 crore, Mitha Homes is your trusted
        partner in making the right choice.
      </p>

      <div style={styles.ctaBox}>
        <div style={styles.phone}>+91 94431 54732</div>

        <p style={styles.ctaText}>
          <strong>Contact Mitha Homes today</strong> to schedule a site visit
          and take the next step toward owning a home that reflects your success
          and aspirations.
        </p>
      </div>
    </div>
  );
};

// export default FindIdealHomeSection;

export default TestmonyTextSection;
